<template>
    <div class="documentos-viewer">
        <div class="header">
            <span>{{ lancamento.Descricao }}</span>
            <a @click="close"><i class="mdi mdi-close"></i></a>
        </div>
        <aside>
            <ul v-if="!loading">
                <li class="titulo">
                    Documentos
                </li>
                <li v-for="documento in documentos" :key="documento.IdDocsprime">
                    <a @click="docsprime_id = documento.IdDocsprime" :class="{selected: documento.IdDocsprime == docsprime_id}">
                        {{ documento.tipoDocumento }}
                    </a>
                </li>
            </ul>
            <div v-else>
                <p class="text-center" >
                    <i class="mdi mdi-spin mdi-loading mdi-48px"></i>
                </p>
            </div>
        </aside>
        
        <div v-if="Documento" style="overflow: auto;">
            <DocumentoViewer class="content" :documento="Documento"></DocumentoViewer>
        </div>
        <div v-else class="no-document">
            <p v-if="showError">Digitalização ainda não realizada para esse item.</p>
        </div>
        
    </div>
</template>
<script>
import api from '/plugins/api';
import DocumentoViewer from './documento-viewer.vue';
export default {
    props: ['lancamento'],
    components: {
        DocumentoViewer
    },
    data() {
        return {
            loading: false,
            errors: [],
            documentos: [],
            docsprime_id: null,
            showError: false,
        }
    },
    computed: {
        condominio() {
            return this.$store.getters.condominio;
        },
        codigo_condominio() {
            if (!this.condominio) {
                return null;
            }
            return this.condominio.codigo;
        },
        codigo_lancamento() {
            return this.lancamento.Codigo;
        },
        Documento() {
            if (!this.docsprime_id || !this.documentos) {
                return null;
            }
            return this.documentos.find(({ IdDocsprime }) => IdDocsprime == this.docsprime_id);
        }        
        
    },
    methods: {
        close() {
            this.$emit('close');
        },
        async loadDocumentos() {
            try {
                this.loading = true;
                this.errors = [];
                this.documentos = [];
                let { data: documentos } = await api.get(`condominios/${this.codigo_condominio}/conta-corrente/${this.codigo_lancamento}/lista-documentos`);
                this.documentos = documentos;
                if (documentos.length != 0) {
                    let [documento] = documentos;
                    this.docsprime_id = documento.IdDocsprime;
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        }
    },
    watch: {
        codigo_lancamento: {
            immediate: true,
            handler() {
                this.loadDocumentos();
            }
        }
    },
    mounted() {
        setTimeout(() => {
            this.showError = true;
        }, 2000);
    },
}
</script>
<style lang="less" scoped>
.documentos-viewer {
    
    .no-document {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%; /* Ocupa a altura total */
        p {
            color: white;
            text-align: center;
        }
    }
    
    &::before {
        content: '';
        background: rgba(0,0,0,0.5);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -1;
    }
    color: white;
    background: var(--primary);
    position: fixed;
    top: 20px;
    left: 20px;
    right: 20px;
    bottom: 20px;
    z-index: 9999;
    display: grid;
    grid-template-columns: 300px 1fr;
    grid-template-rows: 4em 1fr;
    grid-template-areas: 
    "header header"
    "aside content"
    ;
    .header {
        grid-area: header;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: rgba(0,0,0,0.25);
        box-shadow: 0 1px 10px -5px rgba(0,0,0,1);
        a,span {
            color: white;
            padding: 0.5em;
        }
        a {
            i {
                font-size: 2em;
            }
            cursor: pointer;
        }
    }
    aside {
        overflow-y: scroll;
        grid-area: aside;
        width: 300px;
        height: 100%;
        background-color: rgba(0,0,0,0.25);
        box-shadow: 1px 0px 10px -5px black;
        i.mdi {
            color: white;
        }
        ul {
            margin: 0;
            padding: 0;
            li {
                border-bottom: 1px solid rgba(0,0,0,0.25);
                &.titulo {
                    color: white;
                    padding: 0.75em 1em;
                    text-align: center;
                    font-weight: bold;
                }
                a {
                    display: block;
                    color: white;
                    padding: 0.5em 1em;                        
                    cursor: pointer;
                    &:hover, &.selected {
                        text-decoration: none;
                        background-color: rgba(255,255,255,0.25);
                    }
                }
            }
        }
    }
    .content {
        grid-area: content;
        overflow: hidden;
    }
}
</style>